import { useTranslation } from "react-i18next";
import {Divider} from "primereact/divider";
import { Carousel } from 'primereact/carousel';
import { Button } from "primereact/button";

interface CarouselItemTemplate {
  image : string;
  commandTitle : string;
  command: Function;
}

export function HomeView () {
  const {t} = useTranslation();

  const carouselItems = [
    {
      image: 'https://static.unipigstudio.com/pictures/looper_logo_4x4.png',
      commandTitle: 'home.carousel.looper.about',
      command: () => { window.open('https://www.unipigstudio.com/looper/index.html', '_blank')?.focus() }
    }
  ]

  const buildCarouselItemTemplate = (item : CarouselItemTemplate) => {
    return <div className="carousel-card border-1 surface-border border-round m-2 text-center py-5 px-3" >
      <div className="carousel-image mb-3">
        <img src={item.image} className="shadow-2" alt="Looper Streaming app logo" />
      </div>
      <div className="mt-5 flex flex-wrap gap-2 justify-content-center">
          <Button label={t(item.commandTitle)} onClick={() => item.command()} />
      </div>
    </div>
  }

  return <>
    <h1>{t('home.highlights')}</h1>
    <Divider/>
    <Carousel numVisible={1} numScroll={1} value={carouselItems} itemTemplate={buildCarouselItemTemplate} />
    
    <h2>{t('home.about.title')}</h2>
    <Divider/>
    <p>{t('home.about.description')}</p>
    <h2>{t('home.about.what_is_a_unipig')}</h2>
    <Divider/>
    <p>{t('home.about.unipig_description')}</p>
    <h2>{t('home.contact.title')}</h2>
    <Divider/>
    <a className="pink-text" href="mailto:support@unipigstudio.com">support@unipigstudio.com</a>
  </>
}